/** "Worker One", "Worker One and Worker Two", "Worker One, Worker Two and
 * Worker Three" — plain, warm
 * joining for the hand-out-work confirmation copy (design-spec-
 * today-card.md §3.5's exact confirmation text). Ported from the
 * validated mock's `joinNames()`. */
export function joinNames(names: string[]): string {
  const uniq: string[] = [];
  for (const n of names) if (!uniq.includes(n)) uniq.push(n);
  if (uniq.length === 0) return "";
  if (uniq.length === 1) return uniq[0] as string;
  if (uniq.length === 2) return `${uniq[0]} and ${uniq[1]}`;
  return `${uniq.slice(0, -1).join(", ")} and ${uniq[uniq.length - 1]}`;
}
